import MorphingBG from '@js/vendor/morphingBG';

const SELECTORS = {
  item: '.morphing-scene'
}

export default class MorphingScene {
  constructor () {
    this.isLoaded = false
  }

  initialize () {
    this.items = Array.from( RM.Select.el(SELECTORS.item) );
    RM.BM(this, ['onAppInit', 'onAppLoaded', 'onAppLoadedEnded', 'onAppResize']);
    this.isInit();
  }

  init () {
    this.items.forEach( item => new MorphingBG(item) )
  }

  isInit () {
    this.isLoaded = true;
    App.loadProgress += 1;
    App.checkAppLoaded();
  }


  onAppInit() {
  }

  onAppLoaded() {
    if (this.items.length && !App.env.isMobile) {
      this.init();
    }
  }

  onAppLoadedEnded() {
  }

  onAppResize() {
  }
}